import { combineReducers } from 'redux'
import admin from '../modules/admin/reducers'
import budget from '../modules/budget/reducers'
import configuration from '../modules/configuration/reducers'
import core from '../modules/core/reducers'
import houseType from '../modules/houseType/reducers'
import offer from '../modules/offer/reducers'
import plot from '../modules/plot/reducers'
import selection from '../modules/selection/reducers'

export default combineReducers({
  admin,
  budget,
  configuration,
  core,
  houseType,
  offer,
  plot,
  selection,
})



// WEBPACK FOOTER //
// ./src/utils/rootReducer.js